export const SAVED = 'saved';
export const REGISTERED = 'registered';
export const XTRI = 'xtri';
export const MY_RESULTS = 'my_results';
export const PROFILE_TABS = [MY_RESULTS, REGISTERED, SAVED, XTRI];
